<template lang="pug">
  div(class="billing-individual-client-form")
    div(class="billing-individual-client-form__image-wrapper")
      img(
        class="billing-individual-client-form__image"
        src="~/assets/images/rocket.gif"
      )
    h2(class="title-32px fw-700 mb-2") {{ $t('We will setup document management for your needs') }}
    div(class="text-14px fw-300") {{ $t('Join leading companies that have already transformed their business processes') }}
    v-form(
      class="billing-individual-client-form__form"
      @submit.prevent.stop="submit"
    )
      ValidationObserver(
        ref="form"
        slim
        tag="div"
        class="billing-individual-client-form__form-wrapper"
      )
        ValidationProvider(
          v-slot="{ errors }"
          rules="required"
          tag="div"
          class="billing-individual-client-form__form-input full"
          :name="wrapQuotesProviderName($t('Your name'))"
        )
          v-text-field(
            v-model="form.name"
            :error-messages="errors"
            filled
            :label="$t('Your name')"
            hide-details="auto"
          )
        ValidationProvider(
          v-slot="{ errors }"
          rules="required"
          tag="div"
          :name="wrapQuotesProviderName($t('Phone number'))"
        )
          e-input-mask(
            v-model="form.phone"
            mask="mobile"
            :label="$t('Phone number')"
            :error-messages="errors"
            filled
            hide-details="auto"
          )
        ValidationProvider(
          v-slot="{ errors }"
          rules="required"
          tag="div"
          :name="wrapQuotesProviderName($t('Company size'))"
        )
          v-select(
            v-model="form.company_size"
            :items="sizes"
            :label="$t('Company size')"
            filled
            hide-details="auto"
            :error-messages="errors"
          )
      div(class="billing-individual-client-form__actions")
        v-btn(
          type="submit"
          :loading="loading"
          class="w-100 main-button"
        ) {{ $t('Plan demo') }}
</template>

<script>
import EInputMask from '~/components/elements/inputs/e-input-mask'
import validate from '~/mixins/validation/validate'

export default {
  name: 'BillingIndividualClientForm',
  components: { EInputMask },
  mixins: [validate],
  props: {
    closeModal: {
      type: Function,
      default: () => {}
    },
    from: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      loading: false,
      form: {
        name: null,
        phone: null,
        company_size: null
      }
    }
  },
  computed: {
    sizes() {
      return ['1', '2-10', '11-50', '51-200', '501-1000', '1001+']
    }
  },
  methods: {
    async submit() {
      const valid = await this.$refs.form.validate()
      if (!valid) {
        return
      }

      const scriptUrl =
        'https://script.google.com/macros/s/AKfycbxx0mLFMNrwKwp4C_EkZ0cy0EjY0fw2T0MJDRFMG0F63TIlVXqqAnOITQD_pHu6hDFQ/exec'
      const data = new FormData()
      Object.entries(this.form).forEach(([key, value]) => data.append(key, value))
      data.append('created_at', this.$moment().format('DD.MM.YYYY HH:mm:ss'))
      data.append('from_page', this.from)
      try {
        this.loading = true
        await fetch(scriptUrl, {
          method: 'POST',
          body: data
        })
        this.closeModal(true)
      } catch (e) {
        this.closeModal(false)
        this.$handlers.error(e, this)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
.billing-individual-client-form {
  &__image-wrapper {
    display: flex;
    justify-content: center;
    margin-bottom: 16px;
  }

  &__image {
    max-width: 80px;
    max-height: 80px;
    width: 100%;
    height: 100%;
  }

  &__form {
    padding-top: 32px;
  }

  &__form-wrapper {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
  }

  &__form-input {
    &.full {
      grid-column: span 2;
    }
  }

  &__actions {
    padding-top: 32px;
  }
}
</style>
